import { ReactComponent as Play } from 'approot/shared/icons/icon-play.svg';
import Icon, { IconProps } from './icon';

const IconPlay = (props: IconProps) => {
  return <Icon {...props} Svg={Play} />;
};

export default IconPlay;
